import { HistoryService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
function doesRouteMatch(completeUrl, custom = []) {
    if (custom.length === 0) {
        return false;
    }
    return custom.some(item => HistoryService.matchRouteExactWithQueryParam(item, completeUrl));
}
export { doesRouteMatch, };
//# sourceMappingURL=does-route-match.js.map